"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderOneText = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var emotion_1 = require("emotion");
var appStylesBase_1 = require("../../styles/appStylesBase");
var react_redux_1 = require("react-redux");
var getIsMediumScreen_1 = require("../../state/getters/getIsMediumScreen");
var getIsBigScreen_1 = require("../../state/getters/getIsBigScreen");
var HeaderOneText = function (_a) {
    var _b = _a.styles, styles = _b === void 0 ? '' : _b, props = tslib_1.__rest(_a, ["styles"]);
    var isMediumScreen = (0, react_redux_1.useSelector)(function (state) {
        return (0, getIsMediumScreen_1.getIsMediumScreen)({ state: state });
    });
    var isBigScreen = (0, react_redux_1.useSelector)(function (state) {
        return (0, getIsBigScreen_1.getIsBigScreen)({ state: state });
    });
    var isMediumScreenClassname = isMediumScreen ? 'isMediumScreen' : '';
    var isBigScreenClassname = isBigScreen ? 'isBigScreen' : '';
    return (react_1.default.createElement("div", tslib_1.__assign({ className: "HeaderOneText ".concat(isMediumScreenClassname, " ").concat(isBigScreenClassname, " ").concat((0, emotion_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n        font-family: ", ";\n        font-size: ", ";\n        padding-bottom: ", ";\n        font-weight: bold;\n        &:first-letter {\n          text-transform: capitalize;\n        }\n        ", "\n      "], ["\n        font-family: ", ";\n        font-size: ", ";\n        padding-bottom: ", ";\n        font-weight: bold;\n        &:first-letter {\n          text-transform: capitalize;\n        }\n        ", "\n      "])), (0, appStylesBase_1.appStylesBase)().fontFamily.primary, isMediumScreen
            ? (0, appStylesBase_1.appStylesBase)().fontSizes.bigger
            : (0, appStylesBase_1.appStylesBase)().fontSizes.big, isMediumScreen
            ? (0, appStylesBase_1.appStylesBase)().spacing.big
            : (0, appStylesBase_1.appStylesBase)().spacing.medium, styles)) }, props)));
};
exports.HeaderOneText = HeaderOneText;
var templateObject_1;
